import React, { useContext, useEffect, useState } from 'react';
import {makeStyles, Toolbar, useTheme} from '@material-ui/core';
import PageToolbar from '../components/pageToolbar';
import AutoTable from '../components/autoTable';
import { secsToTimeStr } from '../global/dateTimeHelpers';
import API from '../global/api';
import globalContext from '../context/globalContext';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ProgressButton from '../components/progressButton';
import DownloadButton from '../components/downloadButton';
import { localeCurrency, formatConsumptionValue, getUnitLabel } from '../global/helpers';
import { SQLtoUTCDate } from '../global/dateTimeHelpers';
import SearchInput from '../components/searchInput';

const headCells = ["identity","customer","boat_name","pedestal_reference","service_type","start_time","end_time","total_time","consumption","unit","revenue","currency"]

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    minHeight: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}))

const ReportRevenue = props => {

  const theme = useTheme();
  const classes = useStyles(theme);
  const context = useContext(globalContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [ startDate, setStartDate ] = useState(new Date(new Date().setTime(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))));
  const [ endDate, setEndDate ] = useState(new Date());
  
  const formatConsumptionOnly = (val, id) => {
    const row = data.find(r => parseInt(r.id_service) === parseInt(id));
    if(typeof row !== 'undefined') {
      return formatConsumptionValue(val, row.id_unit);
    }
    return val;
  }

  const getUnit = (id) => {
    const row = data.find(r => parseInt(r.id_service) === parseInt(id));
    if(typeof row !== 'undefined') {
      return getUnitLabel(row.id_unit);
    }
    return '';
  }

  const handleLoadReport = () => {

    if(typeof context.profile.data.id_organisation !== 'undefined'){
      setLoading(true);
  
      const params = {
        start: startDate,
        end: endDate,
      };
      if (searchTerm) {
        params.search = searchTerm;
      }

      API.req(`/services/revenue/${context.profile.data.id_organisation}`, 'GET', params).then(
        async res => {
          setLoading(false);

          setData(res.result);

        },
        err => {
            setLoading(false);
            context.showSnack({message: typeof err === 'string' ? err : JSON.stringify(err)}, 'error')
        }
      )
    }
  }

  const getCurrency = (id) => {
    const record = data.find(d => d.id_service === id);
    if(typeof record !== 'undefined')
      return record.currency;
    else
      return context.profile.data.currency;
  }

  useEffect(() => {
    handleLoadReport();
  }, [context.profile])

  useEffect(() => {
    handleLoadReport();
  }, [searchTerm])

  return (
    <div className={classes.container}>

      <PageToolbar label="Revenue Report"></PageToolbar>

      <Toolbar disableGutters={true}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="Start"
            format="dd/MM/yyyy"
            inputVariant="standard"
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            value={startDate}
            onChange={d => setStartDate(d)}
            style={{marginRight: 10}}
          />
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="End"
            format="dd/MM/yyyy"
            inputVariant="standard"
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            value={endDate}
            onChange={d => setEndDate(d)}
          />
        </MuiPickersUtilsProvider>
        <SearchInput
          onSearch={(term) => setSearchTerm(term)}
          onClear={() => setSearchTerm('')}
          placeholder="Search customer or boat..."
        />

        <ProgressButton waiting={loading} variant="contained" color="default" onClick={handleLoadReport}>Generate</ProgressButton>
        <div style={{flex: 1}}></div>
        
        <DownloadButton
          variant="contained"
          color="default"
          data={data}
          orderBy="id_service"
          idCol="id_service"
          headCells={headCells}
          fileName={`revenue`}
          cellReplacementProps={{
            'total_time': (val, id) => secsToTimeStr(val),
            'revenue': (val, id) => localeCurrency(val),
            'consumption': (val, id) => formatConsumptionOnly(val, id),
            'unit': (_val, id) => getUnit(id),
          }}
          handleError={(error) => console.log(error)}
        />
        
      </Toolbar>

      <AutoTable
        rows={data}
        idCol="id_service"
        orderBy="start_time"
        headCells={headCells}
        loading={context.services.status === 'LOADING'}
        cellReplacementProps={{
          'total_time': (val, id) => secsToTimeStr(val),
          'consumption': (val, id) => formatConsumptionOnly(val, id),
          'unit': (_val, id) => getUnit(id),
          'revenue': (val, id) => <b>{localeCurrency(val)}</b>,
          'start_time': (val, id) => SQLtoUTCDate(val),
          'end_time': (val, id) => SQLtoUTCDate(val),
        }} />

    </div>
  );
}

export default ReportRevenue;
